import React from 'react';
import Icon from '@/components/ui/Icon';
import clsx from 'clsx';
import styles from './ImageInfo.module.scss';

interface InfoIconButtonProps {
  onClick: (e: React.MouseEvent) => void;
}

const InfoIconButton = ({ onClick }: InfoIconButtonProps) => (
  <button
    className={clsx(
      styles.infoIconButton,
      'tw-absolute tw-top-2 tw-right-2 tw-w-10 tw-h-10 tw-bg-dark-grey',
      'tw-flex tw-items-center tw-justify-center',
      'tw-rounded-md tw-border-none tw-p-0',
    )}
    type="button"
    onClick={onClick}
  >
    <Icon
      color="white"
      icon="InfoAlternate"
      size="25"
    />
  </button>
);

export default InfoIconButton;
